/* DEFER-01 (24 Oct 2026): puts the product page's lower sections back after the first paint.
   layout/theme.liquid leaves them out of the first HTML and writes their section ids on #bd-deferred. Here they are fetched
   with Shopify's Section Rendering API (5 per request, same address and language as the page), inserted at the same spot in
   the same order, and their scripts run as the parser would have run them: inline scripts first in document order, then the
   external ones in document order. A script that waits for DOMContentLoaded or window load gets called right away, because
   those moments have passed. Starts after window load (when the browser is idle) or at the first scroll / tap / key. */
(function () {
  'use strict';
  // POP-DEFER (24 Oct 2026): there can be more than one placeholder (#bd-deferred in <main> for the lower sections, one at
  // the top of <body> for the card game and teaser pop-up). Each section goes back in front of its own placeholder.
  var phs = [].slice.call(document.querySelectorAll('.bd-deferred[data-bd-deferred]'));
  if (!phs.length || window.__bdDeferred) return;
  window.__bdDeferred = true;
  var ids = [], at = {};
  phs.forEach(function (p) { (p.getAttribute('data-bd-deferred') || '').split(',').filter(Boolean).forEach(function (id) { ids.push(id); at[id] = p; }); });
  if (!ids.length) return;
  var started = false;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1); };
  function later(f) { setTimeout(f, 0); }

  function get(chunk, attempt) {
    // Only ?variant= can change what Liquid renders; other parameters (pb, toolkit, utm_*, fbclid) are left out because
    // Shopify answers ?sections= with a different payload when other parameters come first.
    var v = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
    var url = location.pathname + '?sections=' + chunk.join(',') + (v ? '&variant=' + v : '');
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { // no Accept: application/json (a product URL then answers with the product JSON)
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).catch(function (e) {
      if ((attempt || 0) >= 2) throw e;
      return new Promise(function (res) { setTimeout(res, 800 * ((attempt || 0) + 1)); }).then(function () { return get(chunk, (attempt || 0) + 1); });
    });
  }

  function start() {
    if (started) return;
    started = true;
    var chunks = [];
    for (var i = 0; i < ids.length; i += 5) chunks.push(ids.slice(i, i + 5));
    Promise.all(chunks.map(function (c) { return get(c, 0); })).then(function (parts) {
      var map = {};
      parts.forEach(function (p) { for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) map[k] = p[k]; });
      insert(map);
    }).catch(function (e) {
      if (window.console) console.error('[bd-deferred] sections could not be loaded', e);
      phs.forEach(function (p) { p.removeAttribute('aria-busy'); });
    });
  }

  function insert(map) {
    var inserted = [], k = 0;
    (function step() {
      if (k >= ids.length) { phs.forEach(function (p) { if (p.parentNode) p.parentNode.removeChild(p); }); return runScripts(inserted); }
      var id = ids[k++], html = map[id], ph = at[id];
      if (typeof html === 'string' && html) {
        var t = document.createElement('template');
        t.innerHTML = html;
        var el = t.content.firstElementChild;
        ph.parentNode.insertBefore(t.content, ph);
        if (el) inserted.push(el);
      }
      later(step);
    })();
  }

  // While the moved scripts run, listeners for moments that have already passed are called right away (as they would have been).
  function withShim(fn) {
    var wAdd = window.addEventListener, dAdd = document.addEventListener;
    window.addEventListener = function (type, cb, opt) {
      if (type === 'load' && document.readyState === 'complete' && typeof cb === 'function') { later(function () { cb.call(window, new Event('load')); }); return; }
      if (type === 'DOMContentLoaded' && typeof cb === 'function') { later(function () { cb.call(window, new Event('DOMContentLoaded')); }); return; }
      return wAdd.apply(this, arguments);
    };
    document.addEventListener = function (type, cb, opt) {
      if (type === 'DOMContentLoaded' && typeof cb === 'function') { later(function () { cb.call(document, new Event('DOMContentLoaded')); }); return; }
      return dAdd.apply(this, arguments);
    };
    try { fn(); } finally { window.addEventListener = wAdd; document.addEventListener = dAdd; }
  }

  function clone(old) {
    var s = document.createElement('script');
    for (var i = 0; i < old.attributes.length; i++) { var a = old.attributes[i]; if (a.name !== 'defer' && a.name !== 'async') s.setAttribute(a.name, a.value); }
    return s;
  }

  function runScripts(sections) {
    var inline = [], external = [];
    sections.forEach(function (sec) {
      [].forEach.call(sec.querySelectorAll('script'), function (sc) {
        var type = (sc.getAttribute('type') || '').toLowerCase();
        if (type && type !== 'text/javascript' && type !== 'module' && type !== 'application/javascript') return; // JSON, bd-later, templates stay as they are
        if (sc.src) external.push(sc); else inline.push(sc);
      });
    });
    var i = 0;
    (function nextInline() {
      if (i >= inline.length) return nextExternal(0);
      var old = inline[i++], s = clone(old);
      s.text = old.text;
      withShim(function () { old.parentNode.replaceChild(s, old); });
      later(nextInline);
    })();
    function nextExternal(j) {
      if (j >= external.length) return finish();
      var old = external[j], s = clone(old);
      s.async = false;
      var go = function () { nextExternal(j + 1); };
      s.onload = function () { later(go); };
      s.onerror = function () { later(go); };
      // the script registers its own DOMContentLoaded/load listeners while it runs: catch them only while it executes
      var wAdd = window.addEventListener, dAdd = document.addEventListener;
      window.addEventListener = function (type, cb) {
        if (type === 'load' && document.readyState === 'complete' && typeof cb === 'function') { later(function () { cb.call(window, new Event('load')); }); return; }
        return wAdd.apply(this, arguments);
      };
      document.addEventListener = function (type, cb) {
        if (type === 'DOMContentLoaded' && typeof cb === 'function') { later(function () { cb.call(document, new Event('DOMContentLoaded')); }); return; }
        return dAdd.apply(this, arguments);
      };
      var restore = function () { window.addEventListener = wAdd; document.addEventListener = dAdd; };
      s.addEventListener('load', restore); s.addEventListener('error', restore);
      old.parentNode.replaceChild(s, old);
    }
    function finish() {
      // global helpers that only looked at the page once: run them again for the new sections
      try { if (window.bdOfferScope) window.bdOfferScope(); } catch (e) {}
      try {
        var cc = document.querySelector('script[src*="bd-v155-compare-collapse"]');
        if (cc && document.querySelector('.bd-v33-comparison__table') && !document.querySelector('.bd-compare')) { var s2 = document.createElement('script'); s2.src = cc.src; document.body.appendChild(s2); }
      } catch (e) {}
      try { if (window.bdLater && window.bdLater.run) window.bdLater.run(); } catch (e) {}
      try {
        if (location.hash && location.hash.length > 1 && (window.scrollY || 0) < 40) { var tgt = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (tgt) tgt.scrollIntoView(); }
      } catch (e) {}
      document.dispatchEvent(new CustomEvent('bd:deferred-sections-ready'));
    }
  }

  window.addEventListener('scroll', start, { once: true, passive: true });
  ['touchstart', 'pointerdown', 'keydown'].forEach(function (t) { window.addEventListener(t, start, { once: true, passive: true, capture: true }); });
  function afterLoad() { idle(start, { timeout: 1500 }); }
  if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
})();
